<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="订单号/订单标题/姓名/手机号"
            />
          </el-form-item>
          <el-form-item label="">
            <el-select
              filterable
              v-model="queryForm.step"
              placeholder="订单状态"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              filterable
              v-model="queryForm.channel"
              placeholder="支付类型"
              clearable
            >
              <el-option
                v-for="item in channels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="queryData"
              class="mr-15"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-tickets"
              type="primary"
              @click="exportData"
            >
              导出
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="multipleSelection.length > 0"
              icon="el-icon-money"
              type="warning"
              @click="handleBatchRefund"
            >
              批量退款
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list" @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        width="250"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="商品数量"
        prop="extra.count"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="订单金额" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.payAmount }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="退款金额" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人姓名"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.name }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人手机号"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.tel }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="支付方式"
        show-overflow-tooltip
        :formatter="formatChannel"
      />
      <el-table-column align="left" label="订单状态" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag type="primary" v-if="row.step == 1">待付款</el-tag>
          <el-tag type="success" v-if="row.step == 2">已付款</el-tag>
          <el-tag type="warning" v-if="row.step == 3">待收货</el-tag>
          <el-tag type="warning" v-if="row.step == 4">已核销</el-tag>
          <el-tag type="danger" v-if="row.step == 5">已退款</el-tag>
          <el-tag type="info" v-if="row.step == 6">已取消</el-tag>
          <el-tag type="warning" v-if="row.step == 8">退款中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        width="160"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="130px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleShow(row)" class="mr-10">详情</el-button>
          <el-button v-if="checkOrderRefund(row)" type="text" @click="handleRefund(row)" class="mr-10">退款</el-button>
          <el-button v-if="row.step == 2 && row.basic.shipType == 3" type="text" @click="handleExpress(row)" class="mr-10">发货</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="show" @fetch-data="fetchData" />
    <express ref="express" @fetch-data="fetchData" />
    <product-refund ref="productRefund"></product-refund>
  </div>
</template>

<script>
import moment from 'moment'
import { getProductOrders, exportOrder, batchRefundProductOrder } from '@/api/order'
import { orderChannels, orderChannelOptions, orderSteps } from '@/utils/const'
import {
  filterPrice,
  checkOrderVerify,
  checkOrderRefund,
  checkRefundAmount,
} from '@/utils/tool'
import Detail from './detail.vue'
import Express from './express.vue'
import ProductRefund from './refund.vue'
export default {
  name: 'Product',
  components: { Detail, Express,ProductRefund },
  data() {
    return {
      moment,
      checkOrderRefund,
      channels: orderChannelOptions,
      options: orderSteps,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        step: '',
        channel: '',
        date: null,
      },
      multipleSelection: [],
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/order/products') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async exportData() {
      this.listLoading = true
      const form = Object.assign({}, this.queryForm)
      const date = form.date
      if (date) {
        form.startDate = date[0]
        form.endDate = date[1]
        form.periodMode = 1
      } else {
        form.startDate = ''
        form.endDate = ''
      }
      delete form.date
      delete form.page
      delete form.size
      const res = await exportOrder(form)
      this.listLoading = false
      if (!res) return
      this.$alert(`下载地址：${res.url}`, '商品订单导出', {
        confirmButtonText: '下载',
        callback: (action) => {
          if (action == 'confirm') {
            window.location.href = res.url
          }
        },
      })
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleExpress(row) {
      this.$refs['express'].show(row)
    },
    handleRefund(row) {
      this.$refs.productRefund.showRefund(row.basic && row.basic.productList || [],row)
    },
    async handleBatchRefund() {
      const orderList = []
      for(let index in this.multipleSelection){
        if(this.multipleSelection[index].step != orderSteps.find(e => e.label == '已付款').value)
          return this.$message.warning(`订单不是已付款状态：${this.multipleSelection[index].basic.orderNo}`)
        orderList.push({
          orderId: this.multipleSelection[index].orderId,
          orderNo: this.multipleSelection[index].basic.orderNo,
        })
      }
      this.$confirm(`将对如下订单退款：${orderList.map(e => e.orderNo).join('，')}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ret = await batchRefundProductOrder({
          orderIdList: orderList.map(e => e.orderId),
        })
        if(ret){
          this.$message({
            type: 'success',
            message: '批量退款提交成功，请等待系统处理'
          })
          setTimeout(() => {
            this.fetchData()
          }, 2000)
        }
      }).catch((err) => {
        if(err == 'cancel'){
          this.$message({
            type: 'info',
            message: '已取消批量退款'
          })
        }
      })
    },
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = (row && row.payment && row.payment.channel) || 'UNKOWN'
      return orderChannels[channel]
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const form = Object.assign({}, this.queryForm)
      const date = form.date
      if (date) {
        form.startDate = date[0]
        form.endDate = date[1]
        form.periodMode = 1
      } else {
        form.startDate = ''
        form.endDate = ''
      }
      delete form.date
      const { list, total } = await getProductOrders(form)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.vab-query-form {
  :deep() {
    .el-form-item + .el-form-item {
      margin: 0 0 10px 10px !important;

      .el-button {
        margin: 0 0 0 0 !important;
      }
    }
  }
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
.mr-15 {
  margin: 0 15px !important;
}
.mr-10 {
  margin-right: 10px;
}
</style>
